import { render, staticRenderFns } from "./ButtonChatWithModel.vue?vue&type=template&id=14be6407&scoped=true&"
import script from "./ButtonChatWithModel.vue?vue&type=script&lang=js&"
export * from "./ButtonChatWithModel.vue?vue&type=script&lang=js&"
import style0 from "./ButtonChatWithModel.vue?vue&type=style&index=0&id=14be6407&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14be6407",
  null
  
)

component.options.__file = "ButtonChatWithModel.vue"
export default component.exports